<template>
  <div ref="host" class="ai-md-editor"></div>
</template>

<script>
import { EditorView, keymap } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import {
  defaultKeymap,
  history,
  historyKeymap,
  indentWithTab,
} from '@codemirror/commands';
import { markdown } from '@codemirror/lang-markdown';

export default {
  name: 'AiMarkdownEditor',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(next) {
      if (!this.view) return;
      const current = this.view.state.doc.toString();
      if (next === current) return;
      this.view.dispatch({
        changes: { from: 0, to: current.length, insert: next || '' },
      });
    },
  },
  mounted() {
    const state = EditorState.create({
      doc: this.modelValue || '',
      extensions: [
        EditorView.lineWrapping,
        history(),
        keymap.of([...defaultKeymap, ...historyKeymap, indentWithTab]),
        markdown(),
        EditorView.updateListener.of((update) => {
          if (update.docChanged) {
            this.$emit('update:modelValue', update.state.doc.toString());
          }
        }),
      ],
    });
    this.view = new EditorView({ state, parent: this.$refs.host });
  },
  beforeUnmount() {
    if (this.view) {
      this.view.destroy();
      this.view = null;
    }
  },
};
</script>

<style scoped>
.ai-md-editor {
  overflow: hidden;
  min-height: 320px;
  display: flex;
  flex-direction: column;
}

.ai-md-editor :deep(.cm-editor) {
  flex: 1;
  font-size: 13px;
}

.ai-md-editor :deep(.cm-scroller) {
  font-family: 'Consolas', 'JetBrains Mono', monospace;
  line-height: 1.5;
  min-height: 320px;
  max-height: 560px;
}

.ai-md-editor :deep(.cm-gutters) {
  border-right: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #9ca3af;
}
</style>
